import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useInitialLoadingStore } from "../../stores/initialLoadingStore";

export default async function showInitialLoading(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext)
{
    useInitialLoadingStore().show();
    next();
}
